




























































import Vue, { VNode } from "vue";
import { Component, Prop } from "vue-property-decorator";
import { ConfirmModalModes } from "@/data/enums";
import _ from "@/boot/lodash";
import { IConfirmModalConfirmedEvent } from "@/models/modal";

@Component
export default class ConfirmModal extends Vue {
  // Props

  @Prop({ default: "" })
  public title!: string;

  @Prop({ required: true })
  public message!: string | VNode;

  @Prop({ required: false })
  public closeButtonText!: string;

  @Prop({ required: false, default: "" })
  public confirmButtonText!: string;

  @Prop({ default: true })
  public autoClose!: boolean;

  @Prop({ default: true })
  public startProcessingAtConfirm!: boolean;

  @Prop({
    default: ConfirmModalModes.PIN,
    validator: value => _.values(ConfirmModalModes).includes(value)
  })
  public mode!: ConfirmModalModes;

  @Prop({ default: "is-danger" })
  public type!: string;

  // Data

  public pin = `${_.random(1000, 9999)}`;
  public confirmPin = ``;
  public isProcessing = false;

  // Computed

  public get isPin() {
    return this.mode === ConfirmModalModes.PIN;
  }

  public get isButton() {
    return this.mode === ConfirmModalModes.BUTTON;
  }

  public get validForm(): boolean {
    if (this.isButton) return true;
    return this.pin === this.confirmPin;
  }

  public get messageIsVNode() {
    return (
      this.$_.isObject(this.message) && this.$_.has(this.message, "render")
    );
  }

  // Methods

  public confirm(): void {
    if (this.startProcessingAtConfirm) this.isProcessing = true;
    this.$emit("confirmed", {
      stopProcessing: this.stopProcessing
    } as IConfirmModalConfirmedEvent);
    if (this.autoClose) this.close();
  }

  public close(): void {
    this.$emit("close");
  }

  public stopProcessing() {
    this.isProcessing = false;
  }
}
